import { Host, h } from '@stencil/core';
export class AibaKritiqueRatings {
  constructor() {
    this.handleKritiqueDivHydrated = async () => {
      var _a;
      if ((_a = document.querySelector(`#aiba-kritique-div-${this.sku}`)) === null || _a === void 0 ? void 0 : _a.querySelector('.kr-summary-section')) {
        this.kritiqueWrapperRef.innerHTML = document.querySelector(`#aiba-kritique-div-${this.sku}`).innerHTML;
        const element = document.getElementById(`aiba-kritique-div-${this.sku}`);
        element.remove();
      }
    };
    this.handleLoadKritiqueRating = () => {
      const divPresent = document.querySelector(`#aiba-kritique-div-${this.sku}`);
      if (!divPresent) {
        const section = document.createElement('section');
        section.id = `aiba-kritique-div-${this.sku}`;
        section.style.display = 'none !important';
        document.getElementsByTagName('aiba-app')[0].parentElement.insertBefore(section, document.getElementsByTagName('aiba-app')[0]);
        const insertableKritiqueDiv = `<div class="rx-rating" data-testid="ratings">
        <div
          class="rr-widget-container"
          data-summary-template="listing"
          data-entity-id=${this.sku}
          data-entity-type="product"
        ></div>
      </div>`;
        document.querySelector(`#aiba-kritique-div-${this.sku}`).innerHTML = insertableKritiqueDiv;
        typeof window !== 'undefined'
          ? window.kritiqueInitialized
            ? (document.querySelector(`#aiba-kritique-div-${this.sku}`).innerHTML = insertableKritiqueDiv)
            : null
          : null;
      }
      // Set up MutationObserver instead of DOMSubtreeModified
      const targetNode = document.querySelector(`#aiba-kritique-div-${this.sku}`);
      const config = { childList: true, subtree: true, attributes: true };
      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            this.handleKritiqueDivHydrated();
            observer.disconnect(); // Stop observing after handling
            break;
          }
        }
      });
      observer.observe(targetNode, config);
    };
    this.classes = undefined;
    this.styles = undefined;
    this.upc = undefined;
    this.sku = undefined;
    this.productName = undefined;
    this.kritiqueData = undefined;
  }
  componentWillLoad() {
    this.handleLoadKritiqueRating();
  }
  render() {
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: "kritique-wrapper" }, h("div", { ref: el => (this.kritiqueWrapperRef = el), class: this.classes ? this.classes : '' }))));
  }
  static get is() { return "aiba-kritique-ratings"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-kritique-ratings.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-kritique-ratings.css"]
    };
  }
  static get properties() {
    return {
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "upc": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "upc",
        "reflect": false
      },
      "sku": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "sku",
        "reflect": false
      },
      "productName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-name",
        "reflect": false
      },
      "kritiqueData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "kritique-data",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-kritique-ratings.js.map
